module.exports = __webpack_public_path__ + "static/media/2.9465bab5.png";